import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../../constants'
import * as teamDelete from './delete'
import * as verifications from './verifications'

export * as teamDelete from './delete'

export * as verifications from './verifications'

export const actions = {
  ...verifications.actions,
  ...teamDelete.actions,
}

export const epics = [...verifications.epics, ...teamDelete.epics]

export const reducer = combineReducers({
  delete: teamDelete.reducer,
  verifications: verifications.reducer,
})

export const selectors = {
  delete: ({ [REDUCER_INDEX]: { teams: state } }: { [REDUCER_INDEX]: { teams: ReturnType<typeof reducer> } }) =>
    state.delete,
  verifications: ({ [REDUCER_INDEX]: { teams: state } }: { [REDUCER_INDEX]: { teams: ReturnType<typeof reducer> } }) =>
    state.verifications,
}
